import React, { useEffect, useRef, useState } from 'react'
import { FaChevronDown, FaChevronUp, FaTrash } from 'react-icons/fa';

const ExpandableContainer = ({ open, children, title, date, onDelete,subTitle }) => {

    const [isOpen, setIsOpen] = useState(open);
    const [height, setHeight] = useState(null)

    const handleFilterOpening = () => {
        setIsOpen((prev) => !prev);
    };



    const ref = useRef(null);

    useEffect(() => {
        if (isOpen) setHeight(ref.current?.getBoundingClientRect().height);
        else setHeight(0);
    }, [isOpen]);

    return (
        <div className='flex w-full items-start'>
            <div className="card border-slate-300 border-[1px] my-2 rounded-md w-[100%]">
                <div className='cursor-pointer' onClick={handleFilterOpening}>
                    <div className="px-3 py-5  flex justify-between">
                      <div>
                      <h6 className="font-bold">{title}</h6>
                      <h6 className="text-gray-500 font-semibold text-sm" >{date}</h6>
                      <h6 className="text-gray-500 font-semibold text-sm" >{subTitle}</h6>
                      </div>
                        <div className='flex items-center'>
                            <div className='mx-2 cursor-pointer text-gray-200 hover:text-black' onClick={onDelete}><FaTrash /></div>

                            <button type="button" className="btn">
                                {!isOpen ? (
                                    <FaChevronDown />
                                ) : (
                                    <FaChevronUp />
                                )}
                            </button>
                        </div>
                    </div>
                </div>

                <div className="border-bottom my-collapse" style={{ height }}>
                    <div ref={ref}>
                        <div className="p-3">{children}</div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ExpandableContainer